import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AnnouncementsPage } from "@/features/operator/AnnouncementsPage";

export const Route = createFileRoute("/app/operator/announcements")({
  // ?create=1 opens the new-announcement sheet (e.g. from the dashboard).
  validateSearch: z.object({ create: z.coerce.number().optional().catch(undefined) }),
  component: AnnouncementsPage,
});
